"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _tokens = _interopRequireDefault(require("../../../shared/tokens/tokens"));
var _FlexColumn = require("../../layout/flex/FlexColumn");
var _FlexRow = require("../../layout/flex/FlexRow");
var _Label = _interopRequireDefault(require("../../text/Label"));
var _IconTooltip = _interopRequireDefault(require("../../feedback/tooltip/IconTooltip"));
var _InsightSection = _interopRequireDefault(require("./InsightSection"));
var _jsxRuntime = require("react/jsx-runtime");
var InsightContainerWrapper = _styledComponents.default.div.withConfig({
  displayName: "Insight__InsightContainerWrapper",
  componentId: "sc-1e7lfh8-0"
})(["display:flex;flex-direction:column;border:", " solid ", ";border-radius:", ";padding:16px;min-height:144px;flex:1;height:", ";justify-content:space-between;"], _tokens.default.sky.sys.size.borderwidth.thin, _tokens.default.sky.sys.color.border.decorative, _tokens.default.sky.sys.size.borderradius['2'], function (_ref) {
  var height = _ref.height;
  return height === 'm' ? '144px' : '201px';
});
var SectionRow = _styledComponents.default.div.withConfig({
  displayName: "Insight__SectionRow",
  componentId: "sc-1e7lfh8-1"
})(["display:flex;flex-direction:row;width:100%;"]);
var Insight = function Insight(_ref2) {
  var title = _ref2.title,
    titleTooltip = _ref2.titleTooltip,
    height = _ref2.height,
    children = _ref2.children,
    dataCy = _ref2['data-cy'];
  var childrenArray = _react.default.Children.toArray(children);
  var upperSections = childrenArray.filter(function (_, index) {
    return index % 2 === 0;
  });
  var lowerSections = childrenArray.filter(function (_, index) {
    return index % 2 !== 0;
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(InsightContainerWrapper, {
    height: height,
    "data-cy": dataCy,
    children: [title && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FlexRow.FlexRow, {
      flex: '0',
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Label.default, {
        size: '1',
        children: title || ' '
      }), titleTooltip !== undefined ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconTooltip.default, {
        iconSize: 'm',
        children: titleTooltip
      }) : null]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FlexColumn.FlexColumn, {
      gap: 's',
      alignItems: 'flex-start',
      flex: '0',
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(SectionRow, {
        children: upperSections
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(SectionRow, {
        children: lowerSections
      })]
    })]
  });
};
Insight.Section = _InsightSection.default;
var _default = exports.default = Insight;